import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, MessageCircle } from 'lucide-react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const links = [
    { to: '/habitaciones', label: 'Habitaciones' },
    { to: '/restaurante', label: 'Restaurante' },
    { to: '/galeria', label: 'Galeria' },
    { to: '/contacto', label: 'Contacto' },
  ];

  return (
    <>
      <header className={`navbar ${scrolled ? 'scrolled' : ''}`} data-testid="navbar">
        <nav className="navbar__inner">
          <Link to="/" className="navbar__logo" data-testid="nav-logo">
            <span className="navbar__logo-symbol">&#10022;</span>
            <div className="navbar__logo-text">
              <span className="navbar__logo-name">Maison Dorée</span>
              <span className="navbar__logo-tagline">Hôtel de Luxe</span>
            </div>
          </Link>

          <ul className="navbar__links">
            {links.map(l => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`nav-link-${l.label.toLowerCase()}`}>{l.label}</Link>
              </li>
            ))}
          </ul>

          <div className="navbar__actions">
            <a
              href="https://wa.me/34600000000?text=Hola,%20me%20gustaría%20más%20información%20sobre%20el%20hotel"
              target="_blank"
              rel="noopener noreferrer"
              className="navbar__whatsapp"
              aria-label="Contactar por WhatsApp"
              data-testid="nav-whatsapp"
            >
              <MessageCircle size={18} />
            </a>
            <Link to="/reservar" className="btn-reserve" data-testid="nav-reserve-btn">
              Reservar
            </Link>
          </div>

          <button
            className={`navbar__burger ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
            data-testid="nav-burger"
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>
      </header>

      {/* Mobile menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`} data-testid="mobile-menu">
        <nav className="mobile-menu__nav">
          {links.map((l, i) => (
            <Link
              key={l.to}
              to={l.to}
              className="mobile-menu__link"
              style={{ animationDelay: `${i * 0.08}s` }}
              data-testid={`mobile-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/reservar" className="mobile-menu__cta" data-testid="mobile-reserve-btn">
            Reservar estancia
          </Link>
          <a
            href="https://wa.me/34600000000"
            target="_blank"
            rel="noopener noreferrer"
            className="mobile-menu__whatsapp"
          >
            <MessageCircle size={16} />
            <span>WhatsApp</span>
          </a>
        </nav>
      </div>
    </>
  );
}
